var map = {
	"./car-show.jpg": "6f2e",
	"./slider/slide-1.jpg": "9c5e",
	"./slider/slide-2.jpg": "312d",
	"./slider/slide-3.jpg": "08d5",
	"./slider/slide-4.jpg": "0271",
	"./slider/slide-5.jpg": "8ed7",
	"./slider/slide-6.jpg": "fefd"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "a8ef";